





























































































































































































import { Component, Prop } from "vue-property-decorator";
import { ITag, Tag } from "@/models/tag.entity";
import { TagDataAccessLayer } from "@/store/modules/access-layers/tag.access-layer";
import { ConfigModule } from "@/store/modules/config";
import { $t } from "@/lib/utility/t";
import { handleError } from "@/lib/utility/handleError";
import { icons } from "@/components/utility/IconSelect.vue";
import { IVSelectItem } from "@/lib/interfaces/v-select-item.interface";
import { mixins } from "vue-class-component";
import RulesMixin from "@/mixins/RulesMixin.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import TagChip from "@/components/tag/TagChip.vue";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import TagSideCard from "@/components/tag/TagSideCard.vue";

@Component({
  components: {
    ConfirmActionDialog,
    TagChip,
    TagSideCard
  }
})
export default class CreateTagDialog extends mixins(RulesMixin) implements IDialog {
  readonly getAutocompleteFilter = getAutocompleteFilter;

  @Prop({ required: true })
  partnerId!: string;

  @Prop({ default: false })
  hideButton!: boolean;

  @Prop({ default: false })
  isDialogActive!: boolean;

  tag: ITag = new Tag({ partnerId: this.partnerId });
  isFormValid = false;
  loading = false;
  valueExistsWarning = false;

  showOptions = true;

  view = false;

  get duplicate() {
    const existingTags = TagDataAccessLayer.entities.filter(
      tag => tag.value.toLowerCase() === this.tag.value.toLowerCase()
    );

    if (existingTags.length > 0) {
      return existingTags[0];
    }

    return null;
  }

  get icons(): string[] {
    const options = [""];

    options.push(...icons.map(icon => `mdi-${icon}`));

    return options;
  }

  get colorItems(): IVSelectItem[] {
    return ConfigModule.color.analyticsColors.map(color => ({
      text: color,
      value: color
    }));
  }

  get resourceItems(): IVSelectItem[] {
    return [{ text: $t("enums.ResourceEnum.COMPANY"), value: ResourceEnum.COMPANY }];
  }

  created() {
    this.tag = new Tag({
      partnerId: this.partnerId,
      resources: [ResourceEnum.COMPANY],
      color: ConfigModule.color.analyticsColors[0]
    });
  }

  open() {
    this.resetForm();
    this.isDialogActive = true;
    this.tag.color = this.tag.colors[0];
    this.tag.resources.splice(0);
    this.tag.resources.push(...this.tag.availableResources);
    this.view = false;
    this.$nextTick(() => {
      (this.$refs.titleField as HTMLInputElement)?.focus();
    });
  }

  close() {
    this.resetForm();
    this.isDialogActive = false;
    this.view = false;
  }

  async checkValueExists() {
    if (!this.tag.value) {
      this.valueExistsWarning = false;
      return;
    }

    const existingTags = TagDataAccessLayer.entities.filter(
      tag => tag.value.toLowerCase() === this.tag.value.toLowerCase()
    );

    this.valueExistsWarning = existingTags.length > 0;
  }

  async create() {
    this.loading = true;

    try {
      await this.tag.create();
      this.$emit("created", this.tag);
      this.$emit("update:isDialogActive", false);
      this.close();
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  resetForm() {
    this.tag = new Tag({
      partnerId: this.partnerId,
      resources: [ResourceEnum.COMPANY],
      color: ConfigModule.color.analyticsColors[0]
    });
    this.valueExistsWarning = false;
    (this.$refs.form as any)?.resetValidation();
  }

  valueExistsRule(value: string): string | boolean {
    if (!value) {
      return true;
    }

    const existingTags = TagDataAccessLayer.entities.filter(
      tag => tag.value.toLowerCase() === value.trim().toLowerCase() && tag.id !== this.tag.id
    );

    if (!existingTags.length) {
      return true;
    }

    return $t("components.tag.valueExistsWarning");
  }

  setResources() {
    this.tag.resources.splice(0);
    this.tag.resources.push(...this.tag.availableResources);
  }
}
